"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveableComponentState = void 0;
var MoveableComponentState;
(function (MoveableComponentState) {
    MoveableComponentState["OPEN"] = "open";
    MoveableComponentState["CLOSED"] = "closed";
    MoveableComponentState["MOVING"] = "moving";
    MoveableComponentState["IDLE"] = "idle";
    MoveableComponentState["PARTIALLY_OPEN"] = "partially_open";
    MoveableComponentState["LOCKED"] = "locked";
    MoveableComponentState["TILTED_LEFT"] = "tilted_left";
    MoveableComponentState["TILTED_RIGHT"] = "tilted_right";
})(MoveableComponentState = exports.MoveableComponentState || (exports.MoveableComponentState = {}));
//# sourceMappingURL=MoveableComponentState.js.map